export default "__VITE_ASSET__bf527027__"